export default __webpack_public_path__ + "static/media/Straight Flush.351fecc9.mp3";